import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
//挂载Vuex
Vue.use(Vuex)

//创建VueX对象
const store = new Vuex.Store({
  state:{
    //存放的键值对就是所要管理的状态
    name:'helloVueX',
    loginStatus:0,
    code:0,
    user:'',
    base_url:window.location.href,
    activityInfo:'',
  },
  mutations:{
    //es6语法，等同edit:funcion(){...}
    edit(state,payload){
      state.name = payload.age
      Vue.set(state,"age",15)
    },
    del(state){
      Vue.delete(state,'age')
    },
    setUser(state,payload){
      state.user = payload
    },
    saveActivityInfo(state,payload){
      state.activityInfo = payload;
    }
  },
  getters:{
    nameInfo(state){
      return "姓名:"+state.name
    },
    fullInfo(state,getters){
      return getters.nameInfo+'年龄:'+state.age
    }
  },
  actions:{
    aEdit(context,payload){
      return new Promise((resolve,reject)=>{
        setTimeout(()=>{
          context.commit('edit',payload)
          resolve(111)
        },2000)
      })
    }
    ,
    setLoginStatus(state,payload){
      state.loginStatus = payload
    },
    loginWechatAuth(state,payload){
      return new Promise((resolve,reject)=>{
        api.wechatLogin(payload)
      })
    },

  },
  modules:{
    user
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js